import moment from "moment"


export const toDate = () => {
    return moment().add(1, 'year').endOf('year')
}